export default __webpack_public_path__ + "static/media/img (3).64ffa5db.jpg";